import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { FileGroup } from './file-group';
import { Injectable } from '@angular/core';

@Injectable()
export class FileGroupsApiService {
  nextUrl: string;

  constructor(private http: HttpClient) {}

  fetch(accountId: string, appId: string): Observable<any> {
    const url = `/api/v1/account/${accountId}/file-group/`;
    this.nextUrl = null;
    return this.http.get(url, { params: { app_id: appId }, withCredentials: true }).pipe(
      map((resp: any) => {
        this.nextUrl = resp.nextUrl;
        return this.extractData(resp);
      }),
    );
  }

  create(accountId: string, fileGroup: FileGroup, appId: string): Observable<FileGroup> {
    const url = `/api/v1/account/${accountId}/file-group/`;
    return this.http.post(url, fileGroup, { params: { appId: appId }, withCredentials: true }).pipe(
      map((resp: any) => {
        return FileGroup.fromApiModel(resp.data);
      }),
    );
  }

  update(accountId: string, fileGroup: FileGroup, appId: string): Observable<FileGroup> {
    const url = `/api/v1/account/${accountId}/file-group/${fileGroup.fileGroupId}/`;
    return this.http.put(url, fileGroup, { params: { appId: appId }, withCredentials: true }).pipe(
      map((resp: any) => {
        return FileGroup.fromApiModel(resp.data);
      }),
    );
  }

  delete(accountId: string, fileGroupId: string, appId: string): Observable<FileGroup> {
    const url = `/api/v1/account/${accountId}/file-group/${fileGroupId}/`;
    return this.http.delete(url, { params: { app_id: appId }, withCredentials: true }).pipe(
      map((resp: any) => {
        return FileGroup.fromApiModel(resp.data);
      }),
    );
  }

  extractData(data: any): FileGroup[] {
    const filegroups = [];
    for (const filegroup of data.data) {
      filegroups.push(FileGroup.fromApiModel(filegroup));
    }
    return filegroups;
  }
}
